import { convertToExportedView } from '@estee/elc-service';
import { REVIEW_DETAILS } from '@estee/elc-service-view-names';
import { IReviewDetails } from './ReviewDetails';
import serviceNames from '~setup/RatingsReviewsService';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<IReviewDetails>(
    () => import('./ReviewDetails'),
    REVIEW_DETAILS,
    serviceNames.reviewDetailsViewController
);
